import React, { useEffect, useId, useRef, useState } from 'react';

const AssistantInfoBubble = ({ title = 'What this assistant can do', children }) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const panelId = useId();

  useEffect(() => {
    if (!open) return undefined;

    const handlePointerDown = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };

    document.addEventListener('mousedown', handlePointerDown);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handlePointerDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open]);

  return (
    <div className="aa-info-bubble" ref={rootRef}>
      <button
        type="button"
        className="aa-icon-btn aa-info-bubble__trigger"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-controls={panelId}
        aria-label={title}
        title={title}
      >
        i
      </button>
      {open && (
        <div
          id={panelId}
          className="aa-info-bubble__panel"
          role="tooltip"
          onClick={(e) => e.stopPropagation()}
        >
          <p className="aa-info-bubble__title">{title}</p>
          <div className="aa-info-bubble__body">{children}</div>
        </div>
      )}
    </div>
  );
};

export default AssistantInfoBubble;
